// extracted by mini-css-extract-plugin
export var moreButton = "more-button-module--moreButton--5OGIm";